export default function getPermissionsInitialized() {
  // eslint-disable-next-line no-underscore-dangle
  return window.__LLY_REACT_QUERY_DEV_TOOLS_INITIALIZED__;
}
